/**
 * Seo component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';

import SeoShared from '@landing_academy/shared/components-mantine/Seo';

import { useSiteMetadata } from '../hooks/metadata';
import { useLandingData } from '../hooks/homePage';


function Seo({
  description: pageDescription,
  lang = 'it',
  title: pageTitle,
  stub,
}) {
  const { description, twitter, title, tagline, siteUrl } = useSiteMetadata();
  const { socialFacebook, socialTwitter } = useLandingData();

  return (
    <SeoShared
      description={pageDescription}
      lang={lang}
      meta={[{
        name: 'og:url',
        content: `${siteUrl}${stub ? `/${stub}` : ''}`,
      }]}
      title={pageTitle}
      siteMetadata={{
        description, twitter, title, tagline
      }}
      landingData={{ socialFacebook, socialTwitter }}
      links={[{
        rel: 'preconnect',
        href: 'https://use.typekit.net',
        crossOrigin: true,
      }, {
        rel: 'preconnect',
        href: 'https://use.typekit.net/raq3lqn.css',
      }, {
        rel: 'canonical',
        href: `${siteUrl}${stub ? `/${stub}` : ''}`
      }]}
    />
  );
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
};

export default Seo;
